<ng-container *ngIf="mainForm !== undefined">
  <div [formGroup]="mainForm" class="input-tags-container">
    <ng-select
      #select
      class="{{layoutModifier}}"
      [ngClass]="{
        'dropdown-updated': state === 'updated',
        'dropdown-error': state === 'error',
        'dropdown-required': state === 'required',
        'dropdown-new': state === 'new'
      }"
      [searchable]="true"
      [multiple]="true"
      [items]="_options"
      [isOpen]="false"
      [addTag]="true"
      [selectOnTab]="true"
      [clearable]="clearable"
      [clearOnBackspace]="clearOnBackspace"
      [formControlName]="controlName"
      [maxSelectedItems]="maxSelectedItems"
      [dropdownPosition]="'bottom'"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      [clearAllText]="clearAllLabel ? (clearAllLabel | translate) : ('FORMS.COMMON.CLEAR_ALL' | translate)"
      (add)="onAddEvent($event)"
      (remove)="onRemoveEvent($event)"
      (clear)="onClearEvent()"
      (focusout)="onFocusOutEvent($event)"
    >
    </ng-select>
    <app-form-errors [control]="control"></app-form-errors>
  </div>
</ng-container>
